"use client";

import dynamic from "next/dynamic";

const VideoToMusic = dynamic(() => import("./VideoToMusic").then(mod => ({ default: mod.VideoToMusic })));

export type { VideoToMusicProps } from "./VideoToMusic";
export type { ExtractedFrame, PlayingState, SoundtrackOptions, VideoProcessingResult } from "./types";

export default VideoToMusic;
